<script lang="ts" setup>
import type { IProps } from './UsefulLinks.types'
import UsefulLink from './UsefulLink.vue'

defineProps<IProps>()
</script>

<template>
  <article class="useful-links">
    <div class="useful-links__container">
      <div class="useful-links__content">
        <UsefulLink
          v-for="link in links"
          :key="link.url"
          v-bind="link"
        />
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.useful-links {
  @include section-investor();
  display: grid;
  background-color: $gray-100;

  &__container {
    @include section-investor__container();
  }

  &__content {
    display: grid;
    align-items: stretch;
    grid-auto-flow: row;
    gap: 1.6rem;
  }

  @include atM {
    margin: 0 auto;

    &__content {
      grid-template-columns: repeat(4, 1fr);
      grid-auto-flow: column;
      gap: 2.4rem;
    }
  }
}
</style>
